export const TA_CONTENT = {
  hero: {
    kicker: 'Para assistências técnicas de eletrônicos e equipamentos',
    title: 'Cliente ligando toda hora perguntando se o aparelho já ficou pronto? Isso tem solução.',
    subtitle:
      'Controle a ordem de serviço de cada aparelho, do orçamento aprovado à nota fiscal emitida, com histórico completo e estoque de peças sob controle.',
    cta: 'Quero organizar minha assistência',
    ctaMessage: 'Quero conhecer o sistema para assistência técnica do 77Gestão',
    urgency: 'Cada aparelho sem status claro é um cliente ligando e uma equipe perdendo tempo para responder "deixa eu ver".',
  },

  statsStrip: [
    { number: 'Status claro', label: 'de cada aparelho na assistência', icon: 'fa-solid fa-list-check' },
    { number: 'Zero', label: 'orçamento verbal sem registro', icon: 'fa-solid fa-file-circle-exclamation' },
    { number: '1 sistema', label: 'para OS, peças e nota fiscal', icon: 'fa-solid fa-screwdriver-wrench' },
  ],

  pain: {
    title: 'Reconhece alguma dessas situações na sua assistência técnica?',
    intro:
      'Quem conserta aparelho sabe: o problema não é só técnico, é organização — e sem ela, até o melhor técnico vira refém do caderno de anotações.',
    items: [
      { icon: 'fa-solid fa-list-check', text: 'Aparelho chega na assistência e ninguém sabe dizer, com certeza, em que etapa do conserto ele está.' },
      { icon: 'fa-solid fa-phone-volume', text: 'Cliente liga (ou aparece) toda hora perguntando se já ficou pronto, e a equipe para o que está fazendo para "ir ver".' },
      { icon: 'fa-solid fa-boxes-stacked', text: 'Peça necessária para o conserto está em falta, e só se descobre isso na hora de fechar o serviço.' },
      { icon: 'fa-solid fa-comment-dollar', text: 'Orçamento passado de boca, sem registro formal — e depois vira discussão sobre valor combinado.' },
      { icon: 'fa-solid fa-file-circle-exclamation', text: 'Nota fiscal emitida separada do controle do conserto, com risco de esquecer de faturar o serviço.' },
    ],
  },

  midCta: {
    text: 'E se cada aparelho tivesse um histórico completo, com status, peças usadas e orçamento aprovado, tudo em um só lugar?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do sistema para assistência técnica do 77Gestão',
  },

  solution: {
    title: 'Cada aparelho com status, histórico e orçamento organizados.',
    intro:
      'O 77Gestão conecta ordem de serviço, estoque de peças e faturamento — para você parar de gerenciar a assistência de cabeça ou no caderno.',
    cards: [
      {
        icon: 'fa-solid fa-clipboard-list',
        title: 'Ordem de serviço vinculada ao cliente e ao aparelho',
        text: 'Cada aparelho tem sua OS com histórico do que já foi feito, facilitando responder o cliente sem precisar "ir ver".',
      },
      {
        icon: 'fa-solid fa-file-invoice',
        title: 'Orçamento formal antes do reparo',
        text: 'Registre o orçamento e só inicie o conserto depois da aprovação do cliente — sem valor combinado de boca que depois vira discussão.',
      },
      {
        icon: 'fa-solid fa-boxes-stacked',
        title: 'Controle de estoque de peças',
        text: 'Saiba o que tem disponível de peça antes de prometer prazo ao cliente, evitando conserto parado por falta de item.',
      },
      {
        icon: 'fa-solid fa-file-invoice-dollar',
        title: 'Nota fiscal emitida ao faturar',
        text: 'Feche a ordem de serviço e emita a nota fiscal direto do sistema, sem depender de outro processo separado.',
      },
      {
        icon: 'fa-solid fa-address-book',
        title: 'Histórico do cliente',
        text: 'Veja todos os aparelhos e serviços já feitos para o mesmo cliente, útil para orçar um reparo recorrente.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando a assistência para de operar no caderno',
    intro:
      'Uma assistência técnica de eletrônicos anotava aparelhos recebidos em um caderno e passava orçamento de boca para o cliente. Toda semana havia discussão sobre valor combinado ou prazo prometido.',
    stats: [
      { number: '100%', label: 'dos aparelhos com status visível' },
      { number: '0', label: 'orçamentos verbais sem registro' },
      { number: '1 lugar', label: 'para OS, peças e nota fiscal' },
    ],
    paragraphs: [
      'Depois da implantação, cada aparelho passou a ter uma ordem de serviço com status, peças usadas e orçamento aprovado — visível para qualquer pessoa da equipe responder o cliente.',
      'O orçamento formal reduziu as discussões de valor, e a nota fiscal passou a ser emitida no fechamento da própria ordem de serviço, sem passo separado.',
    ],
    highlight: 'Resultado: cliente respondido na hora, orçamento sem discussão e faturamento sem esquecimento.',
    cta: 'Quero esse nível de controle',
    ctaMessage: 'Vi o resultado e quero entender como organizar minha assistência técnica no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares que mudam a gestão da assistência técnica',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Status de cada aparelho, peças usadas e orçamento aprovado disponíveis a qualquer momento.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Estoque de peças e ordem de serviço vinculados, sem depender de memória ou de caderno.',
      },
      {
        icon: 'fa-solid fa-binoculars',
        title: 'Previsibilidade',
        text: 'Histórico por cliente e por aparelho ajuda a orçar reparo recorrente e a antecipar peça em falta.',
      },
    ],
  },

  differentials: {
    title: 'Por que assistências técnicas escolhem o 77Gestão',
    items: [
      { icon: 'fa-solid fa-link', text: 'Ordem de serviço, estoque de peças e nota fiscal integrados — um lançamento alimenta tudo.' },
      { icon: 'fa-solid fa-puzzle-piece', text: 'Sistema adaptável ao tamanho da assistência, de uma bancada a várias.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: sua equipe começa a lançar ordem de serviço com apoio.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e muito bem avaliado.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'Como o cliente sabe se o aparelho já ficou pronto sem ligar toda hora?',
        answer:
          'A ordem de serviço tem status atualizado, então sua equipe consulta na hora sem precisar "ir ver" o aparelho fisicamente, respondendo o cliente rápido.',
      },
      {
        question: 'O sistema evita que eu prometa um prazo sem ter a peça disponível?',
        answer:
          'O controle de estoque de peças mostra o que está disponível, ajudando a evitar prometer prazo para um conserto que depende de peça em falta.',
      },
      {
        question: 'Como funciona o orçamento antes do reparo?',
        answer:
          'Você registra o orçamento no sistema e só inicia o conserto após a aprovação do cliente, com tudo documentado — sem depender de combinado verbal.',
      },
      {
        question: 'Preciso emitir a nota fiscal em outro sistema separado?',
        answer:
          'Não. A emissão de nota fiscal é integrada, acontecendo no fechamento da própria ordem de serviço.',
      },
      {
        question: 'Minha assistência é pequena, só eu e mais um técnico. Vale a pena?',
        answer:
          'Vale. Mesmo com equipe pequena, o controle de status, peça e orçamento evita retrabalho e discussão com cliente — o sistema se adapta ao tamanho da operação.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de responder "deixa eu ver" para o cliente. Tenha o status de cada aparelho na mão.',
    subtitle:
      'Agende uma demonstração e veja, na prática, como organizar ordem de serviço, estoque de peças e faturamento da sua assistência técnica.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema para assistência técnica do 77Gestão',
  },

  seo: {
    title: 'Sistema para Assistência Técnica de Eletrônicos | 77Gestão',
    description:
      'Software para assistência técnica: ordem de serviço vinculada ao cliente e ao aparelho, controle de peças, orçamento formal e nota fiscal integrada. Agende uma demonstração.',
  },
};
